export default {
  language: {
    name: '中文',
  },
  navbar: {
    index: 'DO Network',
    learn: '学习',
    technology: '技术',
    developer: '开发者',
    community: 'DAO社区',
    join: '加入我们的自治化组织',
    decentralized: 'Decentralized',
  },
  home: {
    title: 'DAO组织的去中心化高性能区块链系统',
    subTitle: ['高度去中心化的事务处理逻辑', '创造DAO事务的可持续拓展性'],
    sanTitle: ['权益委托人选举的499个活跃节点随机性处理各项事务', '每秒处理数千事务，并随着节点性能的提升，可持续扩展事务能力'],
    decentralized: '去中心化',
    high: '高度去中心化的事务处理逻辑----权益委托人选举的499个活跃节点随机性处理各项事务',
    sustainable: '可持续拓展',
    Dao: '创造DAO事务的可持续拓展性----每秒处理数千事务，并随着节点性能的提升，可持续扩展事务能力',
    diversified: '多元化',
    protocol: '开放式的多元化DAO协议----建立开放式的DAO协议工具集，满足各组织多元化需求',
    dual: '双合约',
    WASM: 'WASM+EVM的双合约系统----更广泛友好的智能合约系统，建立DAO的多元化算法',
    browser: '浏览器',
    jump: '跳转浏览器',
    toWallet: '钱包指南',
    toWiki: '跳转技术维基',
    toStake: '委托人质押',
  },
  DAO: {
    index: 'DAO的优势',
    title: 'DO network出色性能与经济模型更好的支持DAO发展',
    logical: 'DAO逻辑治理链发展',
    efficiency: '秒级效率帮助DAO执行',
    fund: '开放式获取DAO基金',
    call: '更易于企业与组织调用',
    technology: '技术优势',
    developers: '开发者提供多元化DAO协议，一旦被使用您将获取长期稳定的奖励',
    economy: 'DO network从底层构架中设计了更易于DAO发展的合约经济模型',
    start: '从这里开始创造你独特的DAO想法',
    build: '创建Do network',
    wiki: '跳转至合约技术维基',
    join: '加入我们的组织',
    tech: '技术',
  },
  Learn: {
    learn: '学习',
    introductory: ' DO network入门',
    overview: 'DO network概述',
    token: 'DO代币',
    network: 'DO network浏览器',
    tool: 'DO network钱包工具',
    decentralized: 'Decentralized Organization Network是一个去中心化性能出色的区块链系统，基于海浪协议可以快速完成链上共识，高效执行DAO事务，设计独有的经济模型推动DAO相关应用的可持续性发展。',
    doWhat: '你可以在DO network中做什么？',
    runNode: '运行一个节点---DO network网络由499个独立的物理节点构成，节点并不限于按时间进入排序，如果达成499个完整节点，那么将会触发委托人选举的所有节点按质押排名和时间顺序进入网络。',
    getRewards: '委托人---你可以更轻松的选择你信任的节点获取更多的奖励。',
    provideIdeas: '开发者---把你的独特想法写成代码，一旦被更多人使用你将得到更多奖励。',
    participationDao: '治理---参与DO生态中的各项DAO事务，共同推进DAO发展',
    detail: ' DO network在不牺牲去中心化网络的前提下，设计了更轻量级的海浪共识协议，可以让整个网络更高效的执行链上事务。我们在开源基础下设计了更具特色的经济模型，建立了社区化的DAO基金长期推动DAO的发展与繁荣。',
    consensus: '海浪共识---通过可控的执行时间选举数据状态最佳的节点建立海浪推动全网共识',
    high: '高效网络---节点通讯不采用逐级转递，全连接状态点对点直达',
    DAG: 'DAG结构---创造区块随机有序的生长形态，TPS性能持续稳定',
    model: '经济模型---推动DAO生态的持续性发展',
    detail2: 'DO是Decentralized Organization Network中的唯一通证，深度的融合在DO network的经济生态中,你可以通过以下方式获取它:',
    way1: '空投活动获取奖励',
    way2: '运行节点获取奖励',
    way3: 'staking获取奖励',
    way4: '贡献代码获取奖励',
    way5: '二级市场购买',
    client: '委托人权益',
    interest1: '你可以通过DO选举质押成为委托人',
    interest2: '委托人可以参与选举可靠稳定的节点，以此获取更多奖励',
    interest3: 'Staking冻结周期------一旦选举了你认为可靠的节点冻结期为7天',
    interest4: '异常判断----你可以通过浏览器工具观察你选举的节点是否工作正常，这会影响你的收益。',
    interest5: '安全可靠---资产私钥自持，任何人无权控制你的质押资产',

  },
  Technology: {
    technology: '技术',
    wiki: 'DO wiki',
    consensus: '海浪共识',
    economy: 'DO 经济',
    staking: 'DO 支持的Staking',
    organization: 'DAO组织',
    jump: '跳转至技术wiki',
    consensusMean: '什么是海浪共识协议？',
    abc: 'ABC',
  },
  Developer: {
    developer: '开发者',
    documentation: '开发者文档',
    application: '部署DAO应用',
    API: 'API文档',
    start: '开始运行节点',
    client: '委托人质押',
  },
  Community: {
    community: 'DAO社区',
    proposal: '社区提案',
    vote: '提案投票',
    approve: '获批提案',
    fund: '获取DAO基金',
    blog: '博客',
    github: 'GitHub',
    twitter: 'Twitter',
    telegram: 'Telegram',
  },
  footer: {
    about: '关于我们',
    view: 'Do network 概述',
    wiki: '技术wiki',
    legal: '法律协议',
    serve: '社区活动',
    privacy: '隐私协议',
    notices: '法律声明',
    partner: '合作伙伴',
    HBTC: 'HBTC',
    token: 'TokenInsight',
    block: '499Block',
    contact: '联系我们',
    email: '邮箱:snajw@163.com',
    join: '加入我们',
    feixiaohao: '非小号',

  },
  Eco: {
    ecoTitle: "DO经济学",
    ecoWhat: "DO支持的标桩",
    ecoDetail:
      "Do Network为客户的选择设计了一种机制。客户端在所有合法节点上投票。每轮投票的冻结期为7天。7天内不得举行第二次选举。在投票冻结期间，客户将参与网络激励。",
    reward: "客户奖励",
    rewardDetails:"一旦公共节点和验证者参与区块奖励，客户端将获得奖金，奖励数量将根据所选验证节点下的委托质押数量比例分配。",
    rule: "客户规则",
    ruleDetail:
      "每个合法验证者可以接受的最大客户端数为500。单个验证节点的委托托管最大数量为250000 DO，最小数量为200 DO。冻结期为7天。",
    tip: "如果您委托的验证节点因TPS上升而关闭或数据状态无法同步，您的收入将受到直接影响",
  },
};
